export const CHARITIES_SECTION_CONSTANTS: { CHARITY: string; } = {
  CHARITY: "charities"
};
